<!-- Tax Residence Header -->
<h2>Skatterättslig hemvist</h2>
<p>Skatterättslig hemvist är det land där en person betalar skatt och
  deklarerar sin inkomst, vanligtvis där personen bor eller arbetar och har
  skatteplikt enligt nationell lagstiftning.</p>
<p>En person kan ha skatterättslig hemvist i flera länder.</p>

@for (country of countries(); track $index) {
  <mat-card>
    <mat-card-content>
      <spb-country [input]="country" [excluded]="countryList()"/>
    </mat-card-content>
  </mat-card>
}
<div class="show-extra-holder">
  <!-- no extra -->
  @if (countries().length === 1) {
    <p>
      Om du vill lägga till skatterättslig hemvist i ytterligare ett
      land, klicka på "Lägg till" nedan.
    </p>

    <!-- one xtrax -->
  } @else if (countries().length === 2) {
    <p>
      Om du vill lägga till eller ta bort skatterättslig hemvist i mer än ett
      land, klicka på "Lägg till" respektive "Ta bort" nedan.
    </p>
    <!-- any extra -->
  } @else if (countries().length === 3) {
    <p>
      Om du vill ta bort skatterättslig hemvist i mer än ett
      land, klicka på "Ta bort" nedan.
    </p>
  }
</div>


<div class="show-extra-holder">
  @if (childrenCount() < 3) {
    <button (click)="addParallell()" class="add-more-button">
      <div class="centered-button">
        <mat-icon>add</mat-icon>
        <span>Lägg till</span>
      </div>
    </button>
  }
  @if (childrenCount() > 1) {
    <button (click)="removeParallel()" class="add-more-button">
      <div class="centered-button">
        <mat-icon>remove</mat-icon>
        <span>Ta bort</span>
      </div>
    </button>
  }
</div>
<!-- US Tax Resident Warning -->
@if (needsUsTax()) {
  <mat-error [style.margin-bottom.rem]="0.75">
    Du har angett medborgarskap i USA. Du behöver även ange Skatterättslig
    hemvist i USA
  </mat-error>
}